import { httpservice } from '../services';
import { constants } from '../constant/constant';
import { ENTITY } from '../constant';

let apiEndPoint = constants.ADMIN_URL;

const loginUser = sessionStorage.getItem('cred') ? JSON.parse(sessionStorage.getItem('cred')).userData : false;

if (loginUser) {
  if (loginUser.role.roleName === 'client') {
    apiEndPoint = constants.CLIENT_URL;
  }
}
export const doClientIPCreate = (data) => httpservice()
  .post(`${apiEndPoint}${constants.API.WHITELISTED_IP}`, data)
  .then((response) => ({ status: 1, data: response.data }))
  .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));

export const doClientIPUpdate = (Id, data) => {
  const endPointUri = constants.API.WHITELISTED_IP_BY_ID.replace(ENTITY.WHITE_IP_ID, Id);
  return httpservice()
    .put(endPointUri, data)
    .then((response) => ({ status: 1, data: response.data }))
    .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));
};

export const doClientIPDelete = (Id) => {
  const endPointUri = constants.API.WHITELISTED_IP_BY_ID.replace(ENTITY.WHITE_IP_ID, Id);
  return httpservice()
    .delete(endPointUri)
    .then((response) => ({ status: 1, data: response.data }))
    .catch((error) => ({ status: 0, data: error.response && error.response.data ? error.response.data : error }));
};

export const doUpdateClientWhitelistIPSetting = (clientId, updateObject) => httpservice()
  .put(`${constants.API.CLIENT_WHITELIST_IP_SETTING}/${clientId}`, updateObject)
  .then((response) => response.data)
  .catch((error) => error.response.data);
